// actionTypes.js
export const SET_CURRENT_PAGE_PARTICIPATION = 'SET_CURRENT_PAGE_PARTICIPATION';
export const SET_VALUE_PARTICIPATION = 'SET_VALUE_PARTICIPATION';
export const SET_SORT_FIELD_PARTICIPATION = 'SET_SORT_FIELD_PARTICIPATION';
export const SET_ORDER_PARTICIPATION = 'SET_ORDER_PARTICIPATION';

